(function(){
  if (window.BridgeElmPersimmonPdpLoaded) return;
  window.BridgeElmPersimmonPdpLoaded = true;

  function closest(el, selector){
    while(el && el.nodeType === 1){
      if(el.matches(selector)) return el;
      el = el.parentElement;
    }
    return null;
  }

  document.addEventListener('click', function(e){
    var thumb = closest(e.target, '.be-thumb');
    if(thumb){
      var root = closest(thumb, '.be-hero');
      var main = root && root.querySelector('.be-main-img img');
      var img = thumb.getAttribute('data-img');
      if(main && img){
        main.src = img;
        root.querySelectorAll('.be-thumb').forEach(function(t){ t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
      }
    }

    var bundle = closest(e.target, '.be-bundle');
    if(bundle){
      var box = closest(bundle, '.be-bundle-box') || document;
      box.querySelectorAll('.be-bundle').forEach(function(b){ b.classList.remove('is-active'); });
      bundle.classList.add('is-active');
      var title = bundle.getAttribute('data-title') || 'Selected Routine';
      var price = bundle.getAttribute('data-price') || '';
      var sub = bundle.getAttribute('data-sub') || '';
      document.querySelectorAll('[data-be-selected-title]').forEach(function(el){ el.textContent = title; });
      document.querySelectorAll('[data-be-selected-sub]').forEach(function(el){ el.textContent = sub; });
      document.querySelectorAll('[data-be-selected-price]').forEach(function(el){ el.textContent = price; });
      document.querySelectorAll('[data-be-cta]').forEach(function(el){ el.textContent = 'Add ' + title + (price ? ' — ' + price : ''); });
      document.querySelectorAll('[data-be-bundle-input]').forEach(function(input){ input.value = title; });
    }
  });

  // ---- Send every Bridge & Elm CTA to the top of the PDP ----
  function beScrollToBuy(){
    var y = window.pageYOffset || document.documentElement.scrollTop || 0;
    window.scrollTo({top: 0, behavior: y > 2500 ? 'auto' : 'smooth'});
  }
  window.beScrollToBuy = beScrollToBuy;
  if (!window.beScroll) { window.beScroll = function(){ beScrollToBuy(); return false; }; }

  document.addEventListener('click', function(e){
    var el = closest(e.target, '[data-be-scroll], a.be-btn, a.becp-cta');
    if(!el) return;
    if(el.tagName === 'BUTTON' && el.type === 'submit' && !el.hasAttribute('data-be-scroll')) return;
    var href = el.getAttribute('href') || '';
    if(href && href.charAt(0) !== '#' && !el.hasAttribute('data-be-scroll')) return;
    e.preventDefault();
    beScrollToBuy();
  });

  function onScroll(){
    var sticky = document.querySelector('.be-sticky-atc');
    if(!sticky) return;
    if(window.scrollY > 760){ sticky.classList.add('is-visible'); }
    else { sticky.classList.remove('is-visible'); }
  }
  window.addEventListener('scroll', onScroll, {passive:true});
  onScroll();
})();
